//# sourceMappingURL=maintenance.mjs.map
/// <reference types="./maintenance.d.mts" />
import * as $durations from "../../../altar/altar/durations.mjs";
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $button from "../../../ds/ds/components/button.mjs";
import * as $callout from "../../../ds/ds/components/callout.mjs";
import * as $combobox from "../../../ds/ds/components/combobox.mjs";
import * as $input from "../../../ds/ds/components/input.mjs";
import * as $l from "../../../ds/ds/components/layout.mjs";
import * as $skeleton from "../../../ds/ds/components/skeleton.mjs";
import * as $toggler from "../../../ds/ds/components/toggler.mjs";
import * as $typography from "../../../ds/ds/components/typography.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $order from "../../../gleam_stdlib/gleam/order.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $calendar from "../../../gleam_time/gleam/time/calendar.mjs";
import * as $duration from "../../../gleam_time/gleam/time/duration.mjs";
import * as $timestamp from "../../../gleam_time/gleam/time/timestamp.mjs";
import * as $window from "../../../magellan/magellan/window.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $event from "../../../redraw/redraw/event.mjs";
import * as $compose from "../../../redraw_batteries/redraw/batteries/compose.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $mouse from "../../../redraw_dom/redraw/dom/event/mouse.mjs";
import * as $e from "../../../redraw_dom/redraw/dom/events.mjs";
import * as $html from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $h from "../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $timestamp_ from "../../../tiamat/gleam/time/timestamp_.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $route from "../../data/route.mjs";
import * as $store from "../../data/store.mjs";
import { Store } from "../../data/store.mjs";
import { Error, toList, isEqual } from "../../gleam.mjs";
import * as $connected_sockets from "../../view/administration/connected_sockets.mjs";
import * as $s from "../../view/administration/maintenance_styles.mjs";

export function use_redirect(store) {
  let dispatch = $store.use_effect_dispatch();
  return ((_capture) => { return $redraw.use_effect(_capture, [store.route]); })(
    () => {
      let pathname = $window.pathname();
      return $bool.guard(
        pathname !== "/",
        undefined,
        () => {
          let _pipe = new $route.Maintenance();
          let _pipe$1 = new $route.Administration(_pipe);
          let _pipe$2 = $route.replace(_pipe$1, store.organization);
          dispatch(_pipe$2);
          return undefined;
        },
      );
    },
  );
}

function add(duration, dispatch) {
  return $e.on_click(
    (event) => {
      let _pipe = event;
      let _pipe$1 = $mouse.as_event(_pipe);
      let _pipe$2 = $event.stop_propagation(_pipe$1);
      $event.prevent_default(_pipe$2);
      let _pipe$3 = new $msg.UserClickedAddDuration(duration);
      dispatch(_pipe$3);
      return undefined;
    },
  );
}

function duration_button(hours, dispatch) {
  let duration = $duration.hours(hours);
  let style = $a.style(toList([["flex", "1"]]));
  let _block;
  {
    if (hours < 0) {
      _block = [$button.secondary, "Remove"];
    } else {
      _block = [$button.primary, "Add"];
    }
  }
  let $ = _block;
  let node = $[0];
  let text = $[1];
  let hours$1 = $int.to_string($int.absolute_value(hours));
  let text$1 = $string.join(toList([text, hours$1, "hour"]), " ");
  return node(
    toList([style, add(duration, dispatch)]),
    toList([$h.text(text$1)]),
  );
}

function on_selected_organization(dispatch, value) {
  let _pipe = value;
  let _pipe$1 = new $msg.UserEditedOrganizationInput(_pipe);
  dispatch(_pipe$1);
  return undefined;
}

function on_submit(dispatch) {
  return $e.on_submit(
    (event) => {
      let _pipe = event;
      let _pipe$1 = $event.prevent_default(_pipe);
      $event.stop_propagation(_pipe$1);
      dispatch(new $msg.UserSubmittedMaintenance());
      return undefined;
    },
  );
}

function use_dispatch() {
  let dispatch = $store.use_dispatch();
  return (m) => { return dispatch(new $msg.MaintenanceMode(m)); };
}

function add_maintenance() {
  return $compose.children(
    $combobox.combobox(),
    (combobox) => {
      return $redraw.component_(
        "Maintenance(Add)",
        (_) => {
          let store = $store.use_state();
          let dispatch = use_dispatch();
          let organizations = store.organizations;
          let maintenance_mode = store.maintenance_mode;
          let _block;
          let _pipe = $option.is_none(maintenance_mode.input_organization);
          let _pipe$1 = $bool.or(
            _pipe,
            isEqual(maintenance_mode.input_from, maintenance_mode.input_to),
          );
          _block = $a.disabled(_pipe$1);
          let disabled = _block;
          return $s.add_card(
            toList([on_submit(dispatch)]),
            toList([
              (() => {
                if (organizations instanceof $remote.NotLoaded) {
                  return $skeleton.full_width(60);
                } else if (organizations instanceof $remote.Loading) {
                  return $skeleton.full_width(60);
                } else if (organizations instanceof $remote.Errored) {
                  return $h.text("Error");
                } else {
                  let organizations$1 = organizations[0][1];
                  let all_selected = isEqual(
                    maintenance_mode.input_organization,
                    new Some("all")
                  );
                  return $redraw.fragment(
                    toList([
                      (() => {
                        let _pipe$2 = $combobox.on_selected_(
                          (_capture) => {
                            return on_selected_organization(dispatch, _capture);
                          },
                        );
                        let _pipe$3 = $combobox.label(_pipe$2, "Organization");
                        let _pipe$4 = $combobox.selected(
                          _pipe$3,
                          maintenance_mode.input_organization,
                        );
                        let _pipe$5 = $combobox.placeholder(
                          _pipe$4,
                          "Select organization",
                        );
                        let _pipe$6 = $combobox.disabled(_pipe$5, all_selected);
                        return combobox(
                          _pipe$6,
                          $list.map(
                            organizations$1,
                            (organization) => {
                              return $combobox.choice(
                                organization.display_name,
                                organization.id,
                              );
                            },
                          ),
                        );
                      })(),
                      $s.select_all(
                        toList([]),
                        toList([
                          $h.text("Freeze application"),
                          $toggler.toggler(
                            toList([
                              $toggler.active(all_selected),
                              $toggler.on_change(
                                (b) => {
                                  dispatch(new $msg.UserToggledAll(b));
                                  return undefined;
                                },
                              ),
                            ]),
                          ),
                        ]),
                      ),
                    ]),
                  );
                }
              })(),
              $input.input(
                (() => {
                  let _pipe$2 = $input.value(
                    $timestamp_.to_datetime_local(maintenance_mode.input_from),
                  );
                  let _pipe$3 = $input.type_(_pipe$2, "datetime-local");
                  let _pipe$4 = $input.label(_pipe$3, "From");
                  return $input.on_input(
                    _pipe$4,
                    (i) => {
                      dispatch(new $msg.UserEditedFromInput(i));
                      return undefined;
                    },
                  );
                })(),
              ),
              $input.input(
                (() => {
                  let _pipe$2 = $input.value(
                    $timestamp_.to_datetime_local(maintenance_mode.input_to),
                  );
                  let _pipe$3 = $input.type_(_pipe$2, "datetime-local");
                  let _pipe$4 = $input.label(_pipe$3, "To");
                  let _pipe$5 = $input.min(
                    _pipe$4,
                    $timestamp_.to_datetime_local(maintenance_mode.input_from),
                  );
                  return $input.on_input(
                    _pipe$5,
                    (i) => {
                      dispatch(new $msg.UserEditedToInput(i));
                      return undefined;
                    },
                  );
                })(),
              ),
              $l.row(
                toList([$l.gap(12)]),
                toList([]),
                toList([
                  duration_button(1, dispatch),
                  duration_button(24, dispatch),
                ]),
              ),
              $l.row(
                toList([$l.gap(12)]),
                toList([]),
                toList([
                  duration_button(-1, dispatch),
                  duration_button(-24, dispatch),
                ]),
              ),
              $s.add_submit(
                toList([]),
                toList([
                  $button.primary(
                    toList([disabled]),
                    toList([$h.text("Submit")]),
                  ),
                ]),
              ),
            ]),
          );
        },
      );
    },
  );
}

function resume_button(org_id, dispatch) {
  return $button.secondary(
    toList([
      $e.on_click(
        (_) => {
          dispatch(new $msg.UserResumedMaintenance(org_id));
          return undefined;
        },
      ),
      $a.style(
        toList([
          ["padding", "4px 18px"],
          ["font-size", "0.75rem"],
          ["line-height", "18px"],
          ["justify-self", "end"],
          ["margin-top", "8px"],
        ]),
      ),
    ]),
    toList([$h.text("Resume")]),
  );
}

function no_active_maintenance() {
  return toList([
    $typography.text(
      $typography.sm,
      $typography.regular,
      "No active maintenance",
    ),
  ]);
}

function active_maintenance() {
  return $redraw.component_(
    "Maintenance(Active)",
    (_) => {
      let store = $store.use_state();
      let dispatch = use_dispatch();
      let organizations = store.organizations;
      let maintenance_mode = store.maintenance_mode;
      let min_size = $a.style(
        toList([["min-width", "200px"], ["min-height", "170px"]]),
      );
      return $l.row(
        toList([$l.gap(12), $l.wrap("wrap")]),
        toList([]),
        (() => {
          let is_empty = $list.is_empty(maintenance_mode.maintenances);
          return $bool.lazy_guard(
            is_empty,
            no_active_maintenance,
            () => {
              return $list.filter_map(
                maintenance_mode.maintenances,
                (_use0) => {
                  let org_id = _use0[0];
                  let maintenance = _use0[1];
                  let is_elapsed = $timestamp.compare(
                    maintenance.ending,
                    $timestamp.system_time(),
                  ) instanceof $order.Lt;
                  return $bool.guard(
                    is_elapsed,
                    new Error(undefined),
                    () => {
                      if (organizations instanceof $remote.NotLoaded) {
                        return new Error(undefined);
                      } else if (organizations instanceof $remote.Loading) {
                        return new Error(undefined);
                      } else if (organizations instanceof $remote.Errored) {
                        return new Error(undefined);
                      } else {
                        let organizations$1 = organizations[0][1];
                        let organization = $list.find(
                          organizations$1,
                          (o) => { return o.id === org_id; },
                        );
                        return $result.map(
                          organization,
                          (organization) => {
                            let start = $timestamp.to_rfc3339(
                              maintenance.starting,
                              $calendar.utc_offset,
                            );
                            let end = $timestamp.to_rfc3339(
                              maintenance.ending,
                              $calendar.utc_offset,
                            );
                            return $callout.info(
                              toList([min_size]),
                              toList([
                                $callout.header(
                                  toList([]),
                                  toList([$h.text(organization.display_name)]),
                                ),
                                $callout.content(
                                  toList([]),
                                  toList([
                                    $html.div(
                                      toList([]),
                                      toList([
                                        $h.text("Maintenance in progress."),
                                      ]),
                                    ),
                                    $html.div(
                                      toList([]),
                                      toList([$h.text("Started: " + start)]),
                                    ),
                                    $html.div(
                                      toList([]),
                                      toList([$h.text("Ending: " + end)]),
                                    ),
                                    $html.div(
                                      toList([]),
                                      (() => {
                                        let ending = $durations.to_ydhms(
                                          maintenance.ending,
                                        );
                                        return toList([
                                          $h.text(
                                            "Ending in approximately: " + ending,
                                          ),
                                        ]);
                                      })(),
                                    ),
                                    resume_button(organization.id, dispatch),
                                  ]),
                                ),
                              ]),
                            );
                          },
                        );
                      }
                    },
                  );
                },
              );
            },
          );
        })(),
      );
    },
  );
}

function frozen_maintenance() {
  return $redraw.component_(
    "Maintenance(Frozen)",
    (_) => {
      let store = $store.use_state();
      let dispatch = use_dispatch();
      let maintenance_mode = store.maintenance_mode;
      let min_size = $a.style(
        toList([["min-width", "200px"], ["min-height", "170px"]]),
      );
      let $ = maintenance_mode.frozen;
      if ($ instanceof $remote.NotLoaded) {
        return $skeleton.skeleton(450, 70);
      } else if ($ instanceof $remote.Loading) {
        return $skeleton.skeleton(450, 70);
      } else if ($ instanceof $remote.Errored) {
        let e = $[0];
        return $callout.error(
          toList([min_size]),
          toList([
            $callout.header(toList([]), toList([$h.text("Frozen")])),
            $callout.content(
              toList([]),
              toList([$h.text("Fetching maintenance bugged: " + e)]),
            ),
          ]),
        );
      } else {
        let $1 = $[0];
        if ($1 instanceof Some) {
          let frozen = $1[0];
          let start = $timestamp.to_rfc3339(
            frozen.starting,
            $calendar.utc_offset,
          );
          let end = $timestamp.to_rfc3339(frozen.ending, $calendar.utc_offset);
          return $callout.warning(
            toList([min_size]),
            toList([
              $callout.header(toList([]), toList([$h.text("Frozen")])),
              $callout.content(
                toList([]),
                toList([
                  $h.text(
                    (("Application is frozen, from " + start) + " to ") + end,
                  ),
                  resume_button("all", dispatch),
                ]),
              ),
            ]),
          );
        } else {
          return $callout.success(
            toList([min_size]),
            toList([
              $callout.header(toList([]), toList([$h.text("Frozen")])),
              $callout.content(
                toList([]),
                toList([$h.text("Application is up & running.")]),
              ),
            ]),
          );
        }
      }
    },
  );
}

export function view() {
  return $redraw.compose(
    frozen_maintenance(),
    (frozen_maintenance) => {
      return $redraw.compose(
        active_maintenance(),
        (active_maintenance) => {
          return $redraw.compose(
            add_maintenance(),
            (add_maintenance) => {
              return $redraw.compose(
                $connected_sockets.list_sockets_connected(),
                (list_sockets_connected) => {
                  return $redraw.component_(
                    "Maintenance",
                    (_) => {
                      let store = $store.use_state();
                      use_redirect(store);
                      return $l.row(
                        toList([$l.justify("space-around"), $l.gap(24)]),
                        toList([]),
                        toList([
                          $l.column(
                            toList([$l.gap(24), $l.align("start")]),
                            toList([]),
                            toList([
                              $typography.h1($typography.md, "Maintenance"),
                              $l.column(
                                toList([$l.gap(48), $l.align("start")]),
                                toList([]),
                                toList([
                                  frozen_maintenance(undefined),
                                  $l.column(
                                    toList([$l.gap(12)]),
                                    toList([]),
                                    toList([
                                      $typography.h2(
                                        $typography.xs,
                                        "Active maintenance",
                                      ),
                                      active_maintenance(undefined),
                                    ]),
                                  ),
                                  $l.column(
                                    toList([$l.gap(12)]),
                                    toList([]),
                                    toList([
                                      $typography.h2(
                                        $typography.xs,
                                        "Add maintenance",
                                      ),
                                      add_maintenance(undefined),
                                    ]),
                                  ),
                                ]),
                              ),
                            ]),
                          ),
                          list_sockets_connected([]),
                        ]),
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}
